import { FC, InputHTMLAttributes, ReactNode, useContext, useEffect, useMemo } from 'react';

import ValidationContext from '../_ValidationContext';

export interface ValidationMessageProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'children'> {
  type: string | string[];
  /** The validation message. Either a string or a function that will receive the current value. */
  children: ReactNode | ((value: any) => ReactNode);
}

/**
 * @mode developer
 */
const ValidationMessage: FC<ValidationMessageProps> = ({ type, children }) => {
  const validationMessageId = useMemo(() => ValidationContext.getNewValidationMessageId(), []);
  const { registerMessage, unregisterMessage } = useContext(ValidationContext);

  useEffect(() => {
    if (Array.isArray(type)) {
      type.forEach((currentType) => {
        registerMessage(validationMessageId, currentType, children);
      });
    } else {
      registerMessage(validationMessageId, type, children);
    }

    return () => {
      unregisterMessage(validationMessageId);
    };
  }, [validationMessageId, registerMessage, unregisterMessage, type, children]);

  return null;
};

/**
 * @component
 * @visibleName ValidationMessage
 */
export default ValidationMessage;
